<template>
	<div>
		<AccountSessionOverlay v-if="!isPrintRoute"/>
		<router-view></router-view>
		<dialogs-wrapper transition-name="modal"></dialogs-wrapper>
		<vue-progress-bar></vue-progress-bar>
	</div>
</template>

<script>
import {isPrintView} from "@/router/utils/routeAccess.js";
import AccountSessionOverlay from "@/core/components/AccountSessionOverlay.vue";

export default {
	components: {AccountSessionOverlay},
	// components: {FileUploader},
	// extends: BaseComponent,
	name: 'App',
	computed: {
		isPrintRoute(){
			return isPrintView(this.$route)
		},
	},

}
</script>
